import { assign } from './utils';
var stringify = function (obj) {
    if (obj === null || obj === undefined || Number.isNaN(obj)) {
        return '';
    }
    var re;
    try {
        re = JSON.stringify(obj);
    }
    catch (_a) {
        re = '';
    }
    return re;
};
var parse = function (search) {
    if (!search) {
        return {};
    }
    var trimedSearch = search.trim().replace(/^(\?|#|&)/, '');
    if (!trimedSearch) {
        return {};
    }
    return trimedSearch
        .split('&')
        .reduce(function (query, s) {
        var _a;
        var m = s.split('=');
        if (m[0]) {
            return assign({}, query, (_a = {},
                _a[m[0]] = decodeURIComponent(m[1]),
                _a));
        }
        return query;
    }, {});
};
export default {
    parse: parse,
    stringify: stringify,
};
//# sourceMappingURL=qs.js.map